<template>
    <span ref="element"></span>
</template>

<script setup>
    const element = ref();

    let tooltip;

    onMounted(() => {
        tooltip = new bootstrap.Tooltip(element.value);
    });

    onUnmounted(() => {
        if (tooltip) {
            tooltip.dispose();
        }
    });
</script>
